import React from 'react';
import { CubeIcon } from '../../../automationStudioIcons';
import styles from '../../../../../styles/automationStudio/automationStudio.module.scss';
import { LABELS } from '../../../content';
import CollapsibleSection from './CollapsibleSection';

export default function FunctionLibrarySection({
    isExpanded,
    onToggle,
    height,
    onResizeStart,
    badge = 0,
}) {
    return (
        <CollapsibleSection
            icon={CubeIcon}
            title={LABELS.SECTION_FUNCTION_LIBRARY}
            badge={badge}
            isExpanded={isExpanded}
            onToggle={onToggle}
            height={height}
            onResizeStart={onResizeStart}
            expandAriaLabel="Expand function library"
            collapseAriaLabel="Collapse function library"
        >
            <div className={styles.emptyState}>
                <p className={`${styles.asTypoBody2} ${styles.asTextSecondary}`}>
                    {LABELS.NO_REUSABLE_FUNCTIONS}
                </p>
            </div>
        </CollapsibleSection>
    );
}
